import { defineComponent as _defineComponent } from 'vue'
import { mdiClose, mdiEye } from '@mdi/js';
import { getFileIcon } from './utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsFileCard',
  props: {
    name: null,
    lastModified: null,
    downloadLink: null,
    identifier: null,
    hideDownload: { type: Boolean },
    hideRemove: { type: Boolean }
  },
  emits: ['click:remove-file'],
  setup(__props: any) {





return { __sfc: true,mdiClose, mdiEye, getFileIcon }
}

})